var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.image.sourceUrl)?_c('source',{attrs:{"srcset":_vm.replaceUrlS3(_vm.image.sourceUrl, _vm.$config),"media":_vm.media}}):_c('source',{attrs:{"srcset":_vm.replaceUrlS3(_vm.imageData.url, _vm.$config),"media":_vm.media}})
}
var staticRenderFns = []

export { render, staticRenderFns }